<template>
  <a-layout-content class="all-c about-us3-content">
    <div class="en" v-show="isEnglish">
      <div class="title-container">
        <h2 class="areas-title">{{ $t('areasTitle') }}</h2>
      </div>
      <div class="list-container">
        <div class="img-box">
          <img src="../../public/3.png" />
        </div>
        <div class="area-item">
          <div v-for="area in areas" :key="area">{{ $t(area) }}</div>
        </div>
      </div>
    </div>
    <div class="cn" v-show="!isEnglish">
      <div class="title-container">
        <h2 class="areas-title">{{ $t('areasTitle') }}</h2>
      </div>
      <div class="list-container">
        <div class="img-box">
          <img src="../../public/3.png" />
        </div>
        <div class="area-item">
          <div v-for="area in areas" :key="area">{{ $t(area) }}</div>
        </div>
      </div>
    </div>
  </a-layout-content>
</template>

<script>
export default {
  data() {
    return {
      isEnglish: true,
      areas: [
        'fineMotorSkillsHard',
        'coordinationAndMotorPlanning',
        'visualPerceptionAndIntegration',
        'selfHelpSkills',
        'attentionChallenges',
        'sensoryProcessingDifferences',
        'selfRegulationDifficulties',
        'executiveFunctionChallenges',
        'learningChallenges',
        'playAndSocialInteractions',
        'difficultyFollowingInstructions',
      ],
    };
  },
  computed: {
    currentLang() {
      return this.$i18n.locale;
    }
  },
  watch: {
    currentLang(newLang) {
      this.isEnglish = newLang === 'en';
    }
  }
};
</script>

<style scoped lang="less">
@mainBg: #f8f5f0;
@mainBg2: #f8f5f1;
@mainColor1: #de94a4;
@mainColor2: #eebac0;
@mainColor3: #A98578;
@mainFont: "MontserratMedium", sans-serif;
@mainFontSub: "MontserratLight", sans-serif;
@mainFontCn: 'Huangchan', sans-serif;
.about-us3-content {
  position: relative;
  height: calc(100vh - 110px);
  background: @mainBg;
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    width: 85vw;
    .title-container {
      .areas-title {
        text-align: center;
        font-size: 2.5vw;
        font-weight: 600;
        color: @mainColor3;
        margin-bottom: 1.5vw;
      }
    }
    
    .list-container {
      display: flex;
      align-items: center;
      .img-box {
        width: 50%;
        padding: 2.8vw;
        img {
          width: 100%;
        }
      }
      .area-item {
        flex: 1;
        transition: background-color 0.3s;
        > div {
          padding: 0.5vw 1.3vw;
          margin: 0.5vw 0;
          font-size: 1vw;
          color: #fff;
          background: @mainColor1;
          border-radius: 100px;
          &:nth-child(even) {
            background: @mainColor2;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .about-us3-content {
    display: flex;
    flex-direction: column;
    padding: 7vw;
    > div {
      .title-container {
        .areas-title {
          font-size: 4vw;
        }
      }
      .list-container {
        flex-direction: column;
        .img-box {
          width: 100%;
          text-align: center;
          img {
            width: 60%;
            margin: 0 auto;
          }
        }
        .area-item {
          width: 100%; 
          > div {
            font-size: 3.3vw;
            padding: 1.5vw 4.5vw;
            margin: 1vw 0;
            height: 4em;
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }  
}
</style>